import React from "react";
import { Flex, Text, Heading, useColorModeValue } from "@chakra-ui/react";

// Pantalla de mantención a pantalla completa: reemplaza toda la app (rutas
// de auth y admin) mientras maintenance.json tenga active=true. Sin iconos
// ni emojis a propósito — solo texto claro, pedido explícito del negocio.
export default function MaintenanceScreen({ title, message }) {
  const bg = useColorModeValue("gray.50", "gray.900");
  const cardBg = useColorModeValue("white", "gray.800");
  const titleColor = useColorModeValue("primary.700", "primary.300");
  const textColor = useColorModeValue("gray.600", "gray.300");

  return (
    <Flex
      minH="100vh"
      w="100%"
      align="center"
      justify="center"
      bg={bg}
      px="24px"
    >
      <Flex
        direction="column"
        bg={cardBg}
        borderRadius="15px"
        boxShadow="0 4px 20px rgba(0, 0, 0, 0.08)"
        maxW="480px"
        w="100%"
        p={{ base: "32px", md: "48px" }}
        textAlign="center"
        align="center"
      >
        <Heading color={titleColor} fontSize="24px" mb="16px">
          {title}
        </Heading>
        <Text color={textColor} fontSize="16px" lineHeight="1.6">
          {message}
        </Text>
      </Flex>
    </Flex>
  );
}
